const data: Record<string, unknown>[] = [
  // PROFILE
  {
    PK: 'PROFILE',
    SK: 'INFO',
    name: 'Damián Jesús González',
    title: 'Platform Engineer · DevOps · Developer Experience',
    title_en: 'Platform Engineer · DevOps · Developer Experience',
    summary:
      'Los mejores equipos de software que vi no solo tienen grandes ingenieros — tienen las condiciones correctas para hacer gran trabajo. Eso fue el norte de mi carrera. Con más de 7 años en DevOps, Cloud y Platform Engineering, trabajé como Lead Solution Architect, construí plataformas internas y lideré arquitectura cloud en entornos enterprise. Hoy mi foco está en acompañar organizaciones de ingeniería en su camino hacia un modelo AI-first — uno que va más allá de adoptar herramientas de IA y transforma cómo los equipos piensan, planifican y ejecutan. Central a este enfoque es mantener a los humanos en el centro. La IA amplifica; los ingenieros deciden.',
    summary_en:
      'The best software teams I\'ve seen don\'t just have great engineers — they have the right conditions to do great work. That\'s been the north star of my career. Over 7+ years in DevOps, Cloud, and Platform Engineering, I\'ve worked as a Lead Solution Architect, built internal platforms, and led cloud architecture across enterprise environments. Today, my focus is on accompanying engineering organizations in their journey toward an AI-first model — one that goes beyond adopting AI tools and instead rewires how teams think, plan, and execute. Central to this approach is keeping humans at the core. AI amplifies; engineers decide.',
    location: 'Córdoba, Argentina',
    languages: {
      spanish: 'Native',
      english: 'Professional Working',
      portuguese: 'Limited Working',
    },
    links: {
      linkedin: 'https://www.linkedin.com/in/ingdamiangonzalez',
      email: 'ing.damian.gonzalez@gmail.com',
    },
  },

  // EXPERIENCE
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#001',
    entityType: 'EXPERIENCE',
    order: 2,
    company: 'Freelance',
    role: 'Cloud Architect & DevOps',
    role_en: 'Cloud Architect & DevOps',
    period: 'Nov 2019 - Present',
    description:
      'Arquitectura cloud, DevOps, Platform Engineering y Developer Experience como freelancer. Construcción de productos con IA. Consultoría en infraestructura y procesos de entrega de software.',
    description_en:
      'Cloud architecture, DevOps, Platform Engineering and Developer Experience as a freelancer. Building products with AI. Consulting on infrastructure and software delivery processes.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#013',
    entityType: 'EXPERIENCE',
    order: 1,
    company: 'Scanntech',
    role: 'Developer Experience & AI-First Engineering',
    role_en: 'Developer Experience & AI-First Engineering',
    period: 'Apr 2026 - Present',
    description:
      'Trabajando junto a equipos de ingeniería para definir e implementar el modelo de ingeniería del futuro: un ecosistema AI-first donde herramientas, procesos y cultura están diseñados para maximizar la capacidad de entrega. Definición del modelo de medición de impacto para equipos de desarrollo (DORA metrics, señales de developer experience). Construcción y despliegue del modelo AI-first: prompt engineering, context featuring y workflows asistidos por IA integrados en la rutina diaria. Diseño del sistema de visibilidad del ciclo de desarrollo: dashboards y reportes desde GitHub, GitLab, ArgoCD y Jira. Definición del modelo de mejora continua a escala.',
    description_en:
      'Working side by side with engineering teams to define and implement the engineering model of the future: an AI-first ecosystem where tools, processes, and culture are designed to maximize delivery capacity. Defining the impact measurement model for development teams (DORA metrics, developer experience signals). Building and rolling out an AI-first model across teams: prompt engineering, context featuring, and AI-assisted workflows into the developer\'s daily routine. Designing the development cycle visibility system: dashboards and reports from GitHub, GitLab, ArgoCD, and Jira. Defining the continuous improvement model at scale.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#002',
    entityType: 'EXPERIENCE',
    order: 3,
    company: 'DinoCloud',
    role: 'MSP Practice Lead',
    period: 'Jan 2025 - Mar 2026',
    description:
      'Liderazgo del programa AWS Managed Service Provider, uno de los más exigentes del ecosistema AWS. Certificación ISO 9001. Desarrollo del producto Rex Copilot validado bajo mejores prácticas AWS. Alianzas estratégicas con software de terceros. Well-Architected Partner Program. 100% del equipo certificado AWS Solutions Architect Associate.',
    description_en:
      'AWS Managed Service Provider program lead — one of the most demanding programs in the AWS ecosystem. ISO 9001 certification. Rex Copilot product development validated under AWS best practices. Strategic partnerships with third-party software. Well-Architected Partner Program. 100% AWS Solutions Architect Associate certified team.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#003',
    entityType: 'EXPERIENCE',
    order: 4,
    company: 'DinoCloud',
    role: 'Lead Solution Architect & Platform Engineering Practice Lead',
    period: 'Feb 2023 - Feb 2025',
    description:
      'Creación de roadmap de Platform Engineering: de cero a Internal Developer Platform completa (CLI + UI). Diseño de herramientas internas con el equipo de foundation. Discovery sessions con clientes. Estrategia técnica alineada a objetivos de negocio. Liderazgo de proyectos de I+D. Evangelización técnica en conferencias y meetups. Preparación y propuesta de programas APN.',
    description_en:
      'Platform Engineering roadmap: from zero to full Internal Developer Platform (CLI + UI). Internal tools design with the foundation team. Customer discovery sessions. Technical strategy aligned with business goals. R&D project leadership. Technical evangelism at conferences and meetups. APN program proposals and submissions.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#004',
    entityType: 'EXPERIENCE',
    order: 5,
    company: 'Inswitch',
    role: 'Sr DevOps/SRE',
    period: 'May 2022 - Jan 2023',
    description:
      'DevOps y SRE senior para empresa fintech en Uruguay. Gestión de infraestructura cloud y pipelines de entrega continua.',
    description_en:
      'Senior DevOps and SRE for fintech company in Uruguay. Cloud infrastructure management and continuous delivery pipelines.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#005',
    entityType: 'EXPERIENCE',
    order: 6,
    company: 'Apes International Group Corp.',
    role: 'Cloud Engineer Manager',
    period: 'Jan 2022 - May 2022',
    description:
      'Infraestructura cloud en AWS para blockchain games (ECS, API Gateway, Lambda, RDS). Gestión del ciclo de vida de aplicaciones de desarrollo a producción. Crecimiento y liderazgo del equipo de Cloud Engineering. Terraform como herramienta de IaC.',
    description_en:
      'Cloud infrastructure on AWS for blockchain games (ECS, API Gateway, Lambda, RDS). Application lifecycle management from development to production. Cloud Engineering team growth and leadership. Terraform for IaC.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#006',
    entityType: 'EXPERIENCE',
    order: 7,
    company: 'Konfío',
    role: 'Cloud Engineer and DevOps',
    period: 'May 2021 - Mar 2022',
    description:
      'Parte de Sr Pago (Konfío). Creación del ecosistema tecnológico para acelerar el delivery. Definición de branch strategy, herramientas de IaC, estrategia de cuentas AWS, organización de equipos, estructura de proyectos en GitLab y selección de stack de lenguajes de programación.',
    description_en:
      'Part of Sr Pago (Konfío). Technology ecosystem creation to accelerate delivery. Branch strategy definition, IaC tooling, AWS account strategy, team organization, GitLab project structure, and programming language stack selection.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#007',
    entityType: 'EXPERIENCE',
    order: 8,
    company: 'Alpha-G',
    role: 'DevOps / Cloud Engineer',
    role_en: 'DevOps / Cloud Engineer',
    period: 'Feb 2020 - Feb 2021',
    description:
      'Freelancer ayudando con la infraestructura del proyecto y resolviendo problemas específicos. Creación de PoC de nuevas tecnologías que el negocio necesitaba.',
    description_en:
      'Freelancer helping with project infrastructure and solving specific problems. PoC creation of new technologies the business needed.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#008',
    entityType: 'EXPERIENCE',
    order: 9,
    company: 'IncluIT (Naranja X)',
    role: 'Cloud Architect and DevOps',
    period: 'Jun 2019 - May 2021',
    description:
      'Caso de éxito publicado por AWS. Migración de EKS a arquitectura serverless con Node.js. Kubernetes, GitLab CI/CD, migraciones on-premise a AWS.',
    description_en:
      'AWS published success case. EKS to serverless architecture migration with Node.js. Kubernetes, GitLab CI/CD, on-premise to AWS migrations.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#009',
    entityType: 'EXPERIENCE',
    order: 10,
    company: 'Universidad Siglo 21',
    role: 'Docente (Cloud Security)',
    role_en: 'Teacher (Cloud Security)',
    period: 'Sep 2019 - May 2020',
    description:
      'Seleccionado como docente en la Diplomatura de Cloud Computing. Creación de todo el contenido para el módulo de Cloud Security.',
    description_en:
      'Selected as teacher in the Cloud Computing program. Full content creation for the Cloud Security module.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#010',
    entityType: 'EXPERIENCE',
    order: 11,
    company: 'Alfred_ai',
    role: 'DevOps and Cloud Engineer',
    role_en: 'DevOps and Cloud Engineer',
    period: 'Feb 2018 - Jun 2019',
    description:
      'Migración de arquitectura monolítica a microservicios. Creación de CI/CD para mejorar la calidad del producto. AWS, Docker, Jenkins, Selenium, SonarQube, Ansible.',
    description_en:
      'Monolithic to microservices architecture migration. CI/CD creation to improve product quality. AWS, Docker, Jenkins, Selenium, SonarQube, Ansible.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#011',
    entityType: 'EXPERIENCE',
    order: 12,
    company: 'DenwaIP',
    role: 'Engineering Manager',
    role_en: 'Engineering Manager',
    period: 'Mar 2015 - Feb 2018',
    description:
      'Coordinación de tareas de ingeniería. I+D de nuevas tecnologías y soluciones. Trabajo con el área comercial en licitaciones y oportunidades. Cloud Computing y Ethical Hacking.',
    description_en:
      'Engineering task coordination. R&D of new technologies and solutions. Sales support in tenders and opportunities. Cloud Computing and Ethical Hacking.',
  },
  {
    PK: 'EXPERIENCE',
    SK: 'ITEM#012',
    entityType: 'EXPERIENCE',
    order: 13,
    company: 'DenwaIP',
    role: 'Ingeniero de Telecomunicaciones',
    role_en: 'Telecommunications Engineer',
    period: 'Aug 2011 - Mar 2015',
    description:
      'Validación e integración con carriers (Telecom, Telefónica, Axtel, Alestra, Telmex) en Argentina, Chile, Perú y México. Trainer Denwa en múltiples países. Investigación de nuevas tecnologías basadas en software open source (Ubuntu Server). Integración con Audiocodes y Sangoma.',
    description_en:
      'Carrier validation and integration (Telecom, Telefónica, Axtel, Alestra, Telmex) across Argentina, Chile, Peru, and Mexico. Denwa trainer in multiple countries. Research on new technologies based on open source software (Ubuntu Server). Integration with Audiocodes and Sangoma.',
  },

  // CERTIFICATIONS
  {
    PK: 'CERTIFICATION',
    SK: 'ITEM#001',
    entityType: 'CERTIFICATION',
    order: 1,
    name: 'AWS Certified Solutions Architect – Associate',
    issuer: 'Amazon Web Services',
    year: 2019,
  },
  {
    PK: 'CERTIFICATION',
    SK: 'ITEM#002',
    entityType: 'CERTIFICATION',
    order: 2,
    name: 'AWS Certified Developer – Associate',
    issuer: 'Amazon Web Services',
    year: 2019,
  },
  {
    PK: 'CERTIFICATION',
    SK: 'ITEM#003',
    entityType: 'CERTIFICATION',
    order: 3,
    name: 'AWS Knowledge: Architecting',
    issuer: 'Amazon Web Services',
    year: 2019,
  },
  {
    PK: 'CERTIFICATION',
    SK: 'ITEM#004',
    entityType: 'CERTIFICATION',
    order: 4,
    name: 'AWS Knowledge: Serverless',
    issuer: 'Amazon Web Services',
    year: 2019,
  },

  // PROJECTS
  {
    PK: 'PROJECT',
    SK: 'ITEM#001',
    entityType: 'PROJECT',
    order: 1,
    name: 'pawaq.media',
    description: 'Producto de IA en construcción. Plataforma de medios potenciada por inteligencia artificial.',
    description_en: 'AI product under construction. AI-powered media platform.',
    techStack: ['AWS', 'AI', 'TypeScript'],
    url: 'https://pawaq.media',
  },
  {
    PK: 'PROJECT',
    SK: 'ITEM#002',
    entityType: 'PROJECT',
    order: 2,
    name: 'personalweb',
    description:
      'Este sitio web. Construido con CDK, React, Bedrock, y documentado en la sección "Cómo me construyeron".',
    description_en:
      'This website. Built with CDK, React, Bedrock, and documented in the "How I Was Built" section.',
    techStack: ['AWS CDK', 'React', 'Bedrock', 'DynamoDB', 'TypeScript', 'GitHub Actions'],
  },

  // SKILLS
  { PK: 'SKILL', SK: 'ITEM#001', entityType: 'SKILL', order: 1, name: 'AWS', category: 'Cloud', level: 5 },
  { PK: 'SKILL', SK: 'ITEM#002', entityType: 'SKILL', order: 2, name: 'CDK', category: 'IaC', level: 5 },
  { PK: 'SKILL', SK: 'ITEM#003', entityType: 'SKILL', order: 3, name: 'Terraform', category: 'IaC', level: 4 },
  { PK: 'SKILL', SK: 'ITEM#004', entityType: 'SKILL', order: 4, name: 'TypeScript', category: 'Languages', level: 4 },
  { PK: 'SKILL', SK: 'ITEM#005', entityType: 'SKILL', order: 5, name: 'Node.js', category: 'Languages', level: 4 },
  { PK: 'SKILL', SK: 'ITEM#006', entityType: 'SKILL', order: 6, name: 'Python', category: 'Languages', level: 3 },
  { PK: 'SKILL', SK: 'ITEM#019', entityType: 'SKILL', order: 19, name: 'AI (full)', category: 'Languages', level: 5 },
  { PK: 'SKILL', SK: 'ITEM#007', entityType: 'SKILL', order: 7, name: 'Docker', category: 'Containers', level: 4 },
  { PK: 'SKILL', SK: 'ITEM#008', entityType: 'SKILL', order: 8, name: 'Kubernetes', category: 'Containers', level: 3 },
  { PK: 'SKILL', SK: 'ITEM#009', entityType: 'SKILL', order: 9, name: 'GitHub Actions', category: 'CI/CD', level: 5 },
  { PK: 'SKILL', SK: 'ITEM#010', entityType: 'SKILL', order: 10, name: 'GitLab CI', category: 'CI/CD', level: 4 },
  { PK: 'SKILL', SK: 'ITEM#011', entityType: 'SKILL', order: 11, name: 'Jenkins', category: 'CI/CD', level: 3 },
  { PK: 'SKILL', SK: 'ITEM#012', entityType: 'SKILL', order: 12, name: 'Serverless', category: 'Architecture', level: 5 },
  { PK: 'SKILL', SK: 'ITEM#013', entityType: 'SKILL', order: 13, name: 'Platform Engineering', category: 'Architecture', level: 5 },
  { PK: 'SKILL', SK: 'ITEM#014', entityType: 'SKILL', order: 14, name: 'AI', category: 'Architecture', level: 4 },
  { PK: 'SKILL', SK: 'ITEM#015', entityType: 'SKILL', order: 15, name: 'DynamoDB', category: 'Databases', level: 4 },
  { PK: 'SKILL', SK: 'ITEM#016', entityType: 'SKILL', order: 16, name: 'React', category: 'Frontend', level: 3 },
  { PK: 'SKILL', SK: 'ITEM#017', entityType: 'SKILL', order: 17, name: 'Linux', category: 'Infrastructure', level: 4 },
  { PK: 'SKILL', SK: 'ITEM#018', entityType: 'SKILL', order: 18, name: 'Ansible', category: 'Infrastructure', level: 3 },
];

export function getMockItems(type: string): Record<string, unknown>[] {
  if (type === 'PROFILE') {
    return data.filter((item) => item.PK === 'PROFILE');
  }
  return data
    .filter((item) => item.PK === type)
    .sort((a, b) => (a.order as number) - (b.order as number));
}
